// extracted by mini-css-extract-plugin
export var actionButton = "_lw-0";
export var actionMenuContainer = "_lw-i";
export var bubble = "_lw-2";
export var bubbleActionMenu = "_lw-j";
export var bubbleContext = "_lw-6";
export var bubbleItems = "_lw-7";
export var customer = "_lw-3";
export var divider = "_lw-8";
export var fileList = "_lw-9";
export var hiddenComment = "_lw-o";
export var infoAbove = "_lw-a";
export var internal = "_lw-4";
export var lightActionButton = "_lw-1";
export var link = "_lw-b";
export var merchant = "_lw-5";
export var message = "_lw-c";
export var profilePicture = "_lw-e";
export var quillToolbarContainer = "_lw-f";
export var senderDate = "_lw-g";
export var senderDateCustomer = "_lw-h";
export var senderName = "_lw-d";
export var time = "_lw-k";
export var uploadedImage = "_lw-l";
export var username = "_lw-m";
export var xsmall = "_lw-n";